import React, { createContext, useContext, useRef, useCallback } from "react";
import CustomAlert from "../components/common/CustomAlert";

const CustomAlertContext = createContext(null);

const CustomAlertProvider = ({ children }) => {
    const alertRef = useRef(null);

    // useCallback을 사용하여 showAlert를 최적화
    const showAlert = useCallback((message) => {
        alertRef.current?.showAlert(message);
    }, []);

    return (
        <CustomAlertContext.Provider value={{ showAlert }}>
            {children}
            <CustomAlert ref={alertRef} />
        </CustomAlertContext.Provider>
    );
};

export default CustomAlertProvider;

export const useCustomAlert = () => {
    const context = useContext(CustomAlertContext);
    if (!context) {
        throw new Error('해당 컨텍스트가 없습니다.');
    }
    return context;
};
